module.exports = __webpack_public_path__ + "static/img/serviceHelp.afb52502.png";